import { createFileRoute } from '@tanstack/react-router';
import { PersonSegmentsRoute } from './-route-wrappers';

/** The person profile's Segments tab, Belongs to, at its own URL. */
function PersonSegmentsBelongsRoute() {
  return <PersonSegmentsRoute view="belongs" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/segments/belongs')({
  component: PersonSegmentsBelongsRoute,
});
